import $ from "jquery";
import word from "icons/word.svg";
import pdf from "icons/pdf.svg";
import excel from "icons/excel.svg";
import Color from "color";
import { DEFAULT_ERROR_MESSAGE } from "constants/app";

export const isExcel = (document) => /\.xls[xmb]?$/i.test(document);
export const isWord = (document) => /\.(doc[xm]?|rtf)$/i.test(document);
export const isPdf = (document) => document?.toLowerCase().endsWith(".pdf");
export const isDocx = (document) => document?.toLowerCase().endsWith(".docx");
export const hasDictionaryPermissions = () => {
  // eslint-disable-next-line no-undef
  return UserInfo.roles.includes("dictionary");
};

export const getImage = (document) => {
  if (isWord(document)) {
    return word;
  }
  if (isPdf(document)) {
    return pdf;
  }
  if (isExcel(document)) {
    return excel;
  }
  return null;
};

export const getCssImage = (document) => {
  if (isWord(document)) {
    return "word-image";
  }
  if (isPdf(document)) {
    return "pdf-image";
  }
  if (isExcel(document)) {
    return "excel-image";
  }
  return null;
};

export const htmlDecode = (input) => {
  const doc = new DOMParser().parseFromString(input, "text/html");
  return doc.documentElement.textContent;
};

export const hoverSame = (index) => {
  $(`.item-${index}`).addClass("hovered");
};
export const unhoverSame = () => {
  $(`.hovered`).removeClass("hovered");
};

export const isNameValid = (name) => {
  const regex = new RegExp(/^[a-zA-Z0-9\-()+. ]+$/i);
  return regex.test(name);
};

/**
 * Example:
 * listOfUsers.toSorted(sortObjectArrayComparator(true, "username"))
 * @param {boolean} asc
 * @param {string} field
 */
export const sortObjectArrayComparator = (asc, field) => (a, b) => {
  if (field) {
    if (a[field] === null) {
      return asc ? -1 : 1;
    }
    if (b[field] === null) {
      return asc ? 1 : -1;
    }
    if (Array.isArray(a[field])) {
      a = a[field][0];
      b = b[field][0];
    } else {
      a = a[field];
      b = b[field];
    }
  }
  if (a === null) {
    return asc ? -1 : 1;
  }
  if (b === null) {
    return asc ? 1 : -1;
  }

  if (Number.isInteger(a) && Number.isInteger(b)) {
    if (a === b) return 0;
    if (asc) return a < b ? -1 : 1;
    return a < b ? 1 : -1;
  }

  if (a.toString().toLowerCase() === b.toString().toLowerCase()) {
    return 0;
  }
  if (asc) {
    return a.toString().toLowerCase() < b.toString().toLowerCase() ? -1 : 1;
  }
  return a.toString().toLowerCase() < b.toString().toLowerCase() ? 1 : -1;
};

export const isUserNameValid = (userName) => {
  const regex = "[/\\\\:*?\"<>|'\\s]";
  const encoded = unescape(encodeURIComponent(userName));
  const containsUTF = !(encoded === userName);
  return !containsUTF && !userName.match(regex);
};

export const arraysEqual = (a, b) => {
  if (a === b) {
    return true;
  }
  // eslint-disable-next-line eqeqeq
  if (a == null || b == null) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }

  // sort arrays by object values to compare order-independent
  a = a
    .slice()
    .sort((x, y) => (JSON.stringify(x) > JSON.stringify(y) ? 1 : -1));
  b = b
    .slice()
    .sort((x, y) => (JSON.stringify(x) > JSON.stringify(y) ? 1 : -1));

  // check each object for equality
  for (let i = 0; i < a.length; ++i) {
    if (JSON.stringify(a[i]) !== JSON.stringify(b[i])) {
      return false;
    }
  }
  return true;
};

// TODO: REMOVE THIS AFTER UPGRADING REACT
/**
 * Generates a random 6 digits number.
 * useId() from React library is preferred for react components,
 * but it's only available from React v18 or higher
 * @returns {number}
 */
export const uniqueId = () => +Math.random().toString().slice(2, 8);

const getPercentageOfNumberBetweenTwoNumbers = (
  minValue,
  maxValue,
  testValue
) => {
  const a = testValue - minValue;
  const b = maxValue - minValue;
  return (a / b) * 100;
};

export const getBackgroundColor = (maxValue, minValue, testValue) => {
  // HSV values for high colour
  const H_HIGH = 189;
  const S_HIGH = 100;
  const V_HIGH = 27;

  // HSV values for low colour
  const H_LOW = 184;
  const S_LOW = 7;
  const V_LOW = 100;

  const colorHigh = Color.hsv(H_HIGH, S_HIGH, V_HIGH);
  const colorLow = Color.hsv(H_LOW, S_LOW, V_LOW);

  let background;

  if (testValue === maxValue && testValue === minValue) {
    background = colorHigh;
  } else if (testValue === maxValue) {
    background = colorHigh;
  } else if (testValue === minValue) {
    background = colorLow;
  } else {
    const percentage =
      getPercentageOfNumberBetweenTwoNumbers(minValue, maxValue, testValue) /
      100;
    const hReturn = H_HIGH * percentage + H_LOW * (1 - percentage);
    const sReturn = S_HIGH * percentage + S_LOW * (1 - percentage);
    const vReturn = V_HIGH * percentage + V_LOW * (1 - percentage);

    background = Color.hsv(hReturn, sReturn, vReturn);
  }
  return background.hex();
};

export const getTextColour = (maxValue, minValue, testValue) => {
  const HEX_BLACK = "#000000";
  const HEX_WHITE = "#FFFFFF";
  let color;
  if (testValue === maxValue && testValue === minValue) {
    color = HEX_WHITE;
  } else if (testValue === minValue) {
    color = HEX_BLACK;
  } else if (testValue === maxValue) {
    color = HEX_WHITE;
  } else {
    const percentage = getPercentageOfNumberBetweenTwoNumbers(
      minValue,
      maxValue,
      testValue
    );
    if (percentage >= 30) {
      color = HEX_WHITE;
    } else {
      color = HEX_BLACK;
    }
  }

  return color;
};

export const renameKeys = (obj, keyMap) => {
  if (Array.isArray(obj)) {
    return obj.map((item) => renameKeys(item, keyMap));
  }
  if (typeof obj === "object" && obj !== null) {
    const newObj = {};
    for (const key in obj) {
      const newKey = keyMap[key] || key;
      newObj[newKey] = renameKeys(obj[key], keyMap);
    }
    return newObj;
  }
  return obj;
};

export const hasVerticalScrollbar = (ref) => {
  const divElement = ref.current;

  if (divElement) {
    return divElement.scrollHeight > divElement.clientHeight;
  }
  return false;
};

export const arraysEqualWithOrder = (array1, array2) => {
  // Check if the arrays have the same length
  if (array1.length !== array2.length) {
    return false;
  }

  // Compare each object in the arrays
  for (let i = 0; i < array1.length; i++) {
    // Convert objects to JSON strings for comparison
    const obj1Str = JSON.stringify(array1[i]);
    const obj2Str = JSON.stringify(array2[i]);

    // Compare JSON strings
    if (obj1Str !== obj2Str) {
      return false;
    }
  }

  // If all objects are the same and in the same order, return true
  return true;
};

export const scrollToTop = (elementRef) => {
  elementRef?.current.scrollTo({ top: 0, behavior: "instant" });
};

export const copyToClipboard = async (textToCopy) => {
  await navigator.clipboard.writeText(textToCopy);

  alert("Link copied to clipboard!");
};

export const refreshPage = () => {
  window.location.reload(false);
};

const buildErrorMessageFromErrorResponse = (errorResponse) => {
  if (typeof errorResponse === "string") {
    if (errorResponse.includes("</html>")) {
      return DEFAULT_ERROR_MESSAGE;
    }
    return errorResponse;
  }
  if (errorResponse.message) {
    return errorResponse.message;
  }
  // Backend returns errorResponse.field which is useful for the developer, but
  // not useful for the user. So we ignore it here but do not want to remove it
  return errorResponse.error;
};

const getErrorMessageFromErrorResponse = (errorResponse) => {
  if (Array.isArray(errorResponse)) {
    return errorResponse
      .map((response) => buildErrorMessageFromErrorResponse(response))
      .join("\n");
  }
  return buildErrorMessageFromErrorResponse(errorResponse);
};

export const getErrorMessage = (error) => {
  if (error.response && error.response.data) {
    return getErrorMessageFromErrorResponse(error.response.data);
  }
  if (error.message) {
    return error.message;
  }
  return DEFAULT_ERROR_MESSAGE;
};

export const setPasswordExpiry = (expiry) =>
  expiry === "-1" ? "Never" : expiry;

export const hasRole = (role) => {
  // eslint-disable-next-line no-undef
  const { roles } = UserInfo;
  return roles.split(",").includes(role);
};

export const compareStringsCaseInsensitive = (s1, s2) => {
  if (typeof s1 !== "string" || typeof s2 !== "string") return false;
  return s1.toLowerCase() === s2.toLowerCase();
};
